import {Component, Input} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';

@Component({
  selector: 'app-sidebar-navigation-button',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar-navigation-button.html'
})
export class SidebarNavigationButton {
  @Input() icon: string = '';
  @Input() name: string = '';
  /** @deprecated use link */
  @Input() route: string = '';
  @Input() link: string[] = [];
}
